import { LucideIcon } from 'lucide-react'

import { Buttons } from '@/components/common/buttons'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

type TaskContent = {
  id: string | number
  title: string
  description: string
  icon: LucideIcon
  url: string
}

interface Props {
  data: {
    contracts: Array<TaskContent>
    calls: Array<TaskContent>
    orders: Array<TaskContent>
  }
  isFetching?: boolean
  refetch?: () => void
}

const TaskDisplayList = ({ data }: { data: Array<TaskContent> }) => {
  return (
    <div className="max-h-[300px] overflow-y-auto pr-2">
      {data.map((ea) => {
        const Icon = ea.icon

        return (
          <div
            key={ea.id}
            className="flex items-center gap-4 border-b border-muted py-4"
          >
            <Icon className="h-6 w-6" strokeWidth={1} />
            <div className="flex-1">
              <p>{ea.title}</p>
              <p className="text-xs text-muted-foreground">{ea.description}</p>
            </div>
            <Buttons.Redirect aria-label="Redirect" to={ea.url} />
          </div>
        )
      })}
      {data.length === 0 && (
        <div className="text-sm text-muted-foreground">
          Nenhuma tarefa pendente
        </div>
      )}
    </div>
  )
}

const TabHeader = ({
  value,
  label,
  count,
}: {
  value: string
  label: string
  count: number
}) => {
  return (
    <TabsTrigger value={value}>
      <div className="flex items-center gap-2">
        <span>{label}</span>
        <span className="flex h-6 w-6 items-center justify-center rounded-sm bg-muted px-2 text-sm font-normal">
          {count}
        </span>
      </div>
    </TabsTrigger>
  )
}

export const TodoList = ({ data, isFetching, refetch }: Props) => {
  return (
    <div>
      <div className="mb-4 flex items-center gap-2">
        <h2 className="text-lg font-normal">Minhas tarefas</h2>
        <Buttons.Refresh isLoading={isFetching} onClick={refetch} />
      </div>

      <Tabs defaultValue="calls">
        <TabsList>
          <TabHeader value="calls" label="Chamados" count={data.calls.length} />
          <TabHeader value="orders" label="Ordens" count={data.orders.length} />
          <TabHeader
            value="contracts"
            label="Contratos"
            count={data.contracts.length}
          />
        </TabsList>
        <TabsContent value="calls">
          <TaskDisplayList data={data.calls} />
        </TabsContent>
        <TabsContent value="orders">
          <TaskDisplayList data={data.orders} />
        </TabsContent>
        <TabsContent value="contracts">
          <TaskDisplayList data={data.contracts} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
